import { makeStyles, Theme } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

interface IStylesProps {
  width: number;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => ({
  rootPopover: {
    "&.darkBackground": {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    }
  },
  paper: {
    width: ({ width }) => `${width}px`,
    minHeight: "264px",
    maxHeight: "75vh",
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      width: "320px"
    }
  },
  header: {
    display: "flex",
    alignItems: "center",
    fontSize: 20,
    width: "100%",
    height: 58,
    padding: "0 20px",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    letterSpacing: "-0.4px"
  },
  headerTitle: {
    display: "block",
    whiteSpace: "nowrap"
  },
  headerIcon: {
    marginRight: 8,
    color: "#998765"
  },
  completeIcon: {
    marginRight: 8,
    color: theme.palette.secondary.dark,
    width: 16,
    height: 16
  },
  content: {
    padding: "0 20px"
  },
  actions: {
    padding: "18px 20px 10px 20px",
    textAlign: "right",
    gap: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      gap: 2
    }
  },
  action: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    whiteSpace: "nowrap"
  },
  actionsAlert: {
    color: "#998765"
  },
  actionsComplete: {
    color: theme.palette.secondary.dark
  },
  actionsUndoComplete: {
    color: "rgba(216, 47, 68, 1)"
  },
  actionsReopen: {
    color: "rgba(153, 135, 101, 1)"
  },
  reason: {
    marginBottom: 16,
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: 1
    }
  },
  reasonInputRoot: {
    fontSize: 14,
    height: 40,
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent"
    }
  },
  reasonPlaceholder: {
    color: theme.palette.text.hint,
    fontSize: 14
  },
  reasonSelectRoot: {
    height: 40
  },
  formHelper: {
    color: theme.palette.text.primary,
    fontSize: 13,
    margin: "0 0 8px 0"
  },
  formHelperText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    lineHeight: "16px"
  },
  formHelperSub: {
    color: theme.palette.text.hint
  },
  note: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.light
      },
      "&:hover fieldset, &.Mui-focused fieldset": {
        borderWidth: 1,
        borderColor: "rgba(0, 0, 0, 0.87)"
      }
    }
  },
  noteCounter: {
    fontSize: 8,
    color: theme.palette.text.secondary,
    bottom: -8
  },
  noteTextarea: {
    "& .MuiInputBase-root": {
      padding: 12,
      color: theme.palette.text.primary
    },
    "& textarea": {
      fontSize: 12
    }
  },
  snackbar: {
    bottom: 60
  },
  snackbarAlert: {
    backgroundColor: "#489B76",
    height: 50,
    fontSize: 16
  },
  reOpenIcon: {
    color: "#998765",
    marginRight: 6
  },
  menuItem: {
    fontSize: 14,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    height: 42,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&.selected": {
      backgroundColor: "rgba(97, 198, 158, 0.15)",
      color: " #103827"
    },
    "&.MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
      backgroundColor: "rgba(97, 198, 158, 0.15)"
    }
  },
  closedMenuItem: {
    borderBottom: "1px solid #eeeeee"
  },
  menuItemContent: {
    display: "flex"
  },
  checkIcon: {
    height: 20
  },
  selectList: {
    padding: 0
  },
  selectText: {
    color: theme.palette.text.primary
  },
  noReason: {
    color: theme.palette.text.hint
  },
  undoCompleteIcon: {
    color: "rgba(216, 47, 68, 1)",
    marginRight: 4,
    transform: "scaleX(-1)"
  },
  actionsUnassign: {
    color: theme.palette.warning.dark
  },
  listWrapper: {
    height: 215,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: 0
    }
  },
  list: {
    padding: 0
  },
  listItem: {
    width: "100%"
  },
  person: {
    width: "100%",
    height: 40,
    marginBottom: 10,
    justifyContent: "left",
    fontSize: 16,
    textTransform: "none",
    lineHeight: "normal",
    "&:hover": {
      background: "rgba(97, 198, 158, 0.15)"
    }
  },
  personWorkOrdersCount: {
    color: theme.palette.text.secondary
  },
  personCheckMark: {
    marginLeft: "auto"
  },
  personSelected: {
    background: "rgba(97, 198, 158, 0.15)",
    borderColor: "#103827",
    color: "#103827",
    "& $personWorkOrdersCount": {
      color: "#103827"
    }
  },
  assignIcon: {
    marginRight: 8,
    color: "rgba(66, 105, 181, 1)"
  },
  reassignIcon: {
    marginRight: 8,
    color: "rgba(66, 105, 181, 1)"
  }
}));
